<template>
  <v-container>
    <!-- Llistat Magatzems -->
    <v-simple-table class="mt-12">
      <thead>
        <v-row>
          <v-col sm="8" offset-sm="1">
            <h1>Llistat de Magatzems</h1>
          </v-col>
          <v-col sm="1" offset-sm="1">
            <!-- Dialog/Modal per crear magatzems -->
            <v-dialog v-model="dialogMagatzem" persistent max-width="600">
              <template v-slot:activator="{ on }">
                <v-btn block color="success" dark v-on="on">+</v-btn>
              </template>
              <v-card>
                <v-card-title class="headline">Crear magatzem</v-card-title>
                <v-container>
                  <v-form id="formMagatzem" ref="formMagatzem" class="mt-12">
                    <v-row>
                      <v-col md="12">
                        <v-text-field v-model="magatzem_nou.nom" label="Nom" required></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12">
                        <v-text-field v-model="magatzem_nou.numero" label="Numero" required></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
                <v-card-actions>
                  <v-btn color="green darken-1" text @click="tancarCrearMagatzem">Cancel·lar</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="btnCrearMagatzem"
                    :disabled="!magatzem_nou.nom"
                  >Crear</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- ./Dialog/Modal per crear magatzem -->
          </v-col>
        </v-row>
      </thead>
      <tbody>
        <tr v-for="magatzem in magatzems" :key="magatzem.id">
          <td class="text-magatzem">
            <div @click="magatzemDetail(magatzem.id)">{{ magatzem.nom }} - Número: {{magatzem.numero}}</div>
            <div>
              <v-btn color="error" dark @click="btnModalEliminar(magatzem.id)">Eliminar </v-btn>
            </div>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <!-- ./Llistat Magatzems -->
    <!-- Dialog/Modal per eliminar magatzem -->
    <v-dialog v-model="dialogEliminarMagatzem" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Eliminar magatzem</v-card-title>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="dialogEliminarMagatzem = false">Cancel·lar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="btnEliminarMagatzem()">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Dialog/Modal per eliminar magatzem -->
    <!-- Paginació -->
    <v-pagination
      v-model="pagina"
      :length="totalPagines"
      @input="paginar()"
      v-if="totalPagines > 1"
    ></v-pagination>
    <!-- ./Paginació -->
    <!-- Footer -->
    <v-footer class="font-weight-medium" height="38%">
      <v-col class="text-center" cols="12" @click="redireccio('Home')" style="padding:0px">
        <span>Gestió Integral Borreres, {{ new Date().getFullYear() }}</span>
      </v-col>
    </v-footer>
    <!-- ./Footer -->
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { EventBus } from "@/event-bus.js";

export default {
  name: "magatzem-llistat",
  data: () => ({
    dialogMagatzem: false,
    dialogEliminarMagatzem: false,
    magatzemEliminarID: null,
    magatzem_nou: {
      nom: ""
    },
    pagina: 1,
    totalPagines: 1
  }),
  computed: {
    ...mapGetters({
      magatzems: "getMagatzems"
    })
  },
  methods: {
    ...mapActions(["eliminarMagatzem", "getMagatzems", "sendMagatzem"]),

    // Paginació
    paginar() {
      this.filtre.pagina = this.pagina;
    },

    // Edició de magatzem
    btnCrearMagatzem() {
      this.sendMagatzem(this.magatzem_nou).then(magatzem => {
        if (magatzem?.data?.id) {
          this.tancarCrearMagatzem();
        }
      });
    },
    btnModalEliminar(magatzem) {
      this.dialogEliminarMagatzem = true;
      this.magatzemEliminarID = magatzem;
    },

    btnEliminarMagatzem() {
      this.eliminarMagatzem(this.magatzemEliminarID).then(response => {
        if (response === 204) {
          EventBus.$emit("Magatzem.Notificacio", {
            text: "Magatzem eliminat correctament",
            color: "success"
          });
          this.dialogEliminarMagatzem = false;
          this.magatzemEliminarID = null;
        } else
          EventBus.$emit("Magatzem.Notificacio", {
            text: "Error eliminant el magatzem",
            color: "error"
          });
      });
    },

    // Rerouting
    magatzemDetail(magatzemID) {
      this.$router.push({
        name: "MagatzemDetail",
        params: { id: magatzemID }
      });
    },
    redireccio(component) {
      this.$router.push({ name: component });
    },

    // Auxiliars
    tancarCrearMagatzem() {
      this.magatzem_nou = {
        nom: ""
      };
      this.dialogMagatzem = false;
    }
  },
  created() {
    this.getMagatzems();
  }
};
</script>
<style lang="scss" scoped>
h1 {
  text-align: center;
  padding-bottom: 1em;
}
.text-magatzem {
  text-align: center;
  font-size: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  div:first-child {
    width: 80%;
  }
  div:nth-child(2) {
    width: 20%;
  }
  // div:nth-child(3) {
  //   width: 20%;
  // }
}
th {
  text-align: right !important;
}
.row {
  margin: 0px;
}
.v-pagination {
  padding-bottom: 50px;
}
</style>